import api from "@/api/api";
import * as Helpers from "@/helpers";

export default {
  async Itens({ commit }) {
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("wkf/controlegrupo", {
        headers
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", resp.data.itens);
      })
      .catch(() => {
        Helpers.logout();
      });
  },
  async Store({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api({
      method: "post",
      url: "wkf/controlegrupo",
      headers,
      data: params
    }).then(resp => {
      localStorage.setItem("token", resp.data.token);
      commit("setItens", resp.data.itens);
    });
  },
  async Delete({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api
      .delete("wkf/controlegrupo/" + params.id_grupo, {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", resp.data.itens);
      })
      .catch(() => {
        Helpers.logout();
      });
  }
};
